



























import transfer from '@/store/types/transfer';
import FilterTransfer from '@/components/TransactionTickets/Transfer/Filters.vue';
import tTransferTable from '@/components/Transfer/tTable.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  components: {
    FilterTransfer,
    tTransferTable,
  },
  data: () => ({
    query: '',
  }),
  computed: {
    ...mapGetters({
      getTransferList: `transfers/${transfer.getters.GET_TRANSFER}`,
    }),
  },
  methods: {
    ...mapActions({
      transferList: `transfers/${transfer.actions.TRANSFER_LIST}`,
    }),
  },
});
